import { ExternalLink } from "lucide-react";
import { cn } from "../../../../utils/utils";
import {
  eventTypeChipColor,
  eventTypeIcon,
} from "../../utils/eventType";
import MessageTimelineCard from "../MessageTimelineCard";

/**
 * Wraps MessageTimelineCard with a header strip showing which bot this log
 * belongs to. Clicking the strip opens the bot's "Tin nhắn" tab in a new tab.
 */
const LogRowWithBot = ({ log, shopsList, eventTypes = [] }) => {
  const botName =
    log.settingDescription || (
      <span className="italic text-gray-400">(Chưa có mô tả)</span>
    );
  const eventType = log.settingEventType;
  const color = eventTypeChipColor(eventType);
  const EventIcon = eventTypeIcon(eventType);
  const eventLabel =
    eventTypes.find((e) => e.action === eventType)?.actionName || eventType || "—";

  const href = log.chatbotSettingId
    ? `/chatbot/settings?botId=${log.chatbotSettingId}&tab=messages`
    : null;

  return (
    <div className="rounded-xl bg-white border border-gray-200 shadow-sm overflow-hidden">
      {/* Bot strip */}
      <a
        href={href || "#"}
        target={href ? "_blank" : undefined}
        rel={href ? "noreferrer" : undefined}
        onClick={(e) => {
          if (!href) e.preventDefault();
        }}
        className={cn(
          "flex items-center gap-2.5 px-3.5 py-2 border-b border-gray-100 transition-colors group",
          href
            ? "hover:bg-indigo-50/50 cursor-pointer"
            : "cursor-default",
        )}
        title={href ? "Mở chi tiết bot trong tab mới" : undefined}
      >
        <span
          className="w-6 h-6 shrink-0 rounded-md flex items-center justify-center"
          style={{ backgroundColor: color + "1a" }}
        >
          <EventIcon size={13} style={{ color }} />
        </span>
        <span className="flex-1 min-w-0">
          <span className="block text-xs font-medium text-gray-800 truncate">
            {botName}
          </span>
          <span className="block text-[11px] text-gray-500 truncate">
            {eventLabel}
          </span>
        </span>
        {href && (
          <span className="inline-flex items-center gap-1 text-[11px] font-medium text-indigo-600 opacity-0 group-hover:opacity-100 transition-opacity">
            Mở bot
            <ExternalLink size={11} />
          </span>
        )}
      </a>

      {/* Inner log card — flat (no outer border) since parent already provides it */}
      <div className="[&_>div]:border-0 [&_>div]:shadow-none [&_>div]:rounded-none">
        <MessageTimelineCard log={log} shopsList={shopsList} />
      </div>
    </div>
  );
};

export default LogRowWithBot;
